import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import DaVideoView from './components/DaVideoView';
import { deleteExtension } from '../../components/utils/tiptap';
export var MenuState = /*#__PURE__*/ function(MenuState) {
    MenuState[MenuState["HIDDEN"] = 0] = "HIDDEN";
    MenuState[MenuState["SHOW"] = 1] = "SHOW";
    return MenuState;
}({});
export const DaVideo = Node.create({
    name: 'da-video',
    group: 'block unlinkable',
    inline: false,
    needsFixAfterPaste: false,
    addStorage () {
        return {
            menuState: 0
        };
    },
    addOptions () {
        return {
            HTMLAttributes: {},
            canAlign: true,
            defaultWidth: 780,
            defaultHeight: 438,
            smallMedia: false
        };
    },
    addAttributes () {
        var _this_options_defaultAlignment;
        return {
            src: {
                default: null
            },
            alignment: {
                default: (_this_options_defaultAlignment = this.options.defaultAlignment) !== null && _this_options_defaultAlignment !== void 0 ? _this_options_defaultAlignment : 'center'
            }
        };
    },
    /**
   * Used to parse incoming html, usually via paste
   */ parseHTML () {
        return [
            {
                tag: `figure[data-da-type="${this.name}"]`,
                getAttrs (node) {
                    if (!node || !node.getAttribute) {
                        return false;
                    }
                    const dataType = node.getAttribute('data-da-type');
                    if (!dataType || dataType !== this.name) {
                        return false;
                    }
                    try {
                        var _node_getAttribute, _node_getAttribute1;
                        return {
                            src: (_node_getAttribute = node.getAttribute('data-src')) !== null && _node_getAttribute !== void 0 ? _node_getAttribute : '',
                            alignment: (_node_getAttribute1 = node.getAttribute('data-alignment')) !== null && _node_getAttribute1 !== void 0 ? _node_getAttribute1 : undefined
                        };
                    } catch (e) {}
                    return null;
                }
            }
        ];
    },
    renderHTML ({ HTMLAttributes: { src, alignment } }) {
        return [
            'div',
            mergeAttributes({
                'data-da-type': this.name,
                'data-src': src,
                'data-alignment': alignment,
                class: 'node-da-video'
            }),
            [
                'div',
                {
                    class: 'react-video-placeholder'
                }
            ]
        ];
    },
    addNodeView () {
        return ReactNodeViewRenderer(DaVideoView);
    },
    onSelectionUpdate () {
        if (this.editor.isActive('da-video')) {
            this.editor.commands.daVideoOpenSettingsMenu();
        } else {
            this.editor.commands.daVideoCloseSettingsMenu();
        }
    },
    addCommands () {
        return {
            daVideoOpenSettingsMenu: ()=>({ editor, chain, dispatch })=>{
                    if (dispatch) {
                        this.storage.menuState = 1;
                    }
                    return true;
                },
            daVideoCloseSettingsMenu: ()=>({ editor, chain, dispatch })=>{
                    if (dispatch) {
                        this.storage.menuState = 0;
                    }
                    return true;
                },
            daVideoAlign: (alignment)=>({ editor, chain, dispatch, commands })=>{
                    if (!this.options.canAlign) {
                        return false;
                    }
                    if (dispatch) {
                        return commands.updateAttributes(this.name, {
                            alignment
                        });
                    }
                    return true;
                },
            daVideoReplace: ({ src })=>({ editor, chain, dispatch, commands, state })=>{
                    this.storage.menuState = 1;
                    if (dispatch) {
                        commands.updateAttributes(this.name, {
                            src
                        });
                        return true;
                    }
                    return true;
                },
            daVideoDelete: ()=>({ editor, chain, dispatch, commands, state })=>{
                    if (deleteExtension('da-video', editor, dispatch, state)) {
                        this.storage.menuState = 0;
                        return true;
                    }
                    return true;
                }
        };
    }
});

//# sourceMappingURL=daVideo.js.map